jQuery(document).ready(function($) {

  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */

  /* GALLERY-SLIDER --------------------------------------------- */
  $('.gallery-slider-block').each(function() {

    var $container = $(this);
    var $slider_container = $('.gallery-slider', $container);
    var $slider = $('> .wrap', $slider_container);
    var $nav_prev = $('.slider--prev', $slider_container);
    var $nav_next = $('.slider--next', $slider_container);
    var autoplay = ( $container.hasClass('autoplay-slider') ? true : false );
    var autoplay_speed = ( autoplay ? $container.data('autoplay-speed') : 4000 );
    var transition_speed = ( autoplay ? $container.data('transition-speed') : 1000 );
    
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });
    
    $slider.on('init reInit breakpoint', function(slick) {
      
      // Make sure slider is visible
      $slider_container.addClass('show');
     
    });

    // Set slider variables
    var slider_args = {
      centerMode: true,
      centerPadding: '105px',
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      regionLabel: 'Gallery Slider',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            centerPadding: '20%',
            slidesToShow: 1
          }
        }
      ]
    };

    // Set autoplay variables if necessary
    if (autoplay) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = autoplay_speed;
      slider_args['speed'] = transition_speed;
    }

    $slider.slick(slider_args);

  });

  /* LOGO SLIDER ------------------------------------------------ */
  $('.logos-slider-block').each(function() {

    var $container = $(this);
    var $slider_container = $('.logos-slider', $container);
    var $slider = $('> .wrap', $slider_container);
    var $nav = $('.slider-nav', $container);
    var $nav_prev = $('.slider--prev', $nav);
    var $nav_next = $('.slider--next', $nav);
    var autoplay = ( $container.hasClass('autoplay-slider') ? true : false );
    var autoplay_speed = ( autoplay ? $container.data('autoplay-speed') : 4000 );
    var transition_speed = ( autoplay ? $container.data('transition-speed') : 1000 );
    
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });

    // Set the min-height of items so they're the same height
    function set_slide_height() {

      // Reset the items
      $('.item', $slider).each(function() {
        $(this).css({
          'min-height': ''
        });
      });

      // Set initial min_height to 0
      var min_height = 0;

      // Check each item and set min_height as needed
      $('.item .image', $slider).each(function() {
        if ($(this).innerHeight() > min_height) {
          min_height = $(this).innerHeight();
        }
      });

      // Set the min-height of each item
      $('.item', $slider).each(function() {
        $(this).css({
          'min-height': min_height+'px'
        });
      });

    }
    
    $slider.on('init reInit breakpoint', function(slick) {
      
      // Make sure slider is visible
      $slider_container.addClass('show');

      // Set slide heights to be equal
      set_slide_height();
     
    });

    $(window).on('resize', st_throttle(500, function() {
      set_slide_height();
    }));

    // Set slider variables
    var slider_args = {
      centerMode: true,
      centerPadding: '105px',
      dots: false, 
      arrows: false,
      infinite: true,
      regionLabel: 'Logos Slider',
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            centerPadding: '200px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1301,
          settings: {
            centerPadding: '150px',
            slidesToShow: 3
          }
        },
        {
          breakpoint: 801,
          settings: {
            centerPadding: '200px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 501,
          settings: {
            centerPadding: '70px',
            slidesToShow: 1
          }
        }
      ]
    };

    // Set autoplay variables if necessary
    if (autoplay) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = autoplay_speed;
      slider_args['speed'] = transition_speed;
    }

    $slider.slick(slider_args);

  });

  /* POSTS GRID ------------------------------------------------- */
  $('.posts-block, .grantees-block').each(function() {

    // Declare variables
    $container = $(this);
    $filter = $('.post-grid-filtering', $container);
    $category_filter = $('select[name="filter-category"]', $filter);
    $sorting_filter = $('select[name="sort-by"]', $filter);
    $text_search = $('input[name="filter-text"]', $filter);

    $text_search.on('focus', function() {
      if ($(this).val() == 'Search') {
        $(this).val('');
      }
    });

    $text_search.on('blur', function() {
      if ($(this).val() == '') {
        $(this).val('Search');
      }
    });

    $filter.on('submit', function() {
      if ($text_search.val() == 'Search') {
        $text_search.val('');
      }
    });

    $category_filter.on('change', function() {
      $filter.submit();
    });

    $sorting_filter.on('change', function() {
      $filter.submit();
    });

  });


  /* STATS SLIDER ----------------------------------------------- */
  $('.stats-slider').each(function() {

    function set_stat_height() {

      // Reset min-height of all stats
      $('.stat-item', $slider).css({
        'min-height': ''
      });

      // Set variable for min-height
      var min_height = 0;

      // Iterate over each stat, finding the tallest slide
      $('.stat-item', $slider).each(function() {
        var this_height = $(this).innerHeight();
        if (this_height > min_height) {
          min_height = this_height;
        }        
      });

      // Set min-height of all stats
      $('.stat-item', $slider).css({
        'min-height': min_height+'px'
      });

    }

    function set_navigation_visibility() {

      // Count the active slides
      var active_slides = $('.slick-active', $slider).length;

      // Set visibility of navigation
      if (active_slides < slide_count) {
        $navigation.addClass('show');
      } else {
        $navigation.removeClass('show');
      }

    }

    // Define elements
    var $container = $(this);
    var $slider = $('> .wrap', $container);
    var slide_count = $('.stat-wrap', $slider).length;
    var $navigation = $('.stats-nav', $container);
    var $nav_prev = $('button.prev', $navigation);
    var $nav_next = $('button.next', $navigation);
      
    // Set navigation buttons
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });

    // Handle initiation, reinitiation, etc.
    $slider.on('init reInit breakpoint', function(slick) {

      // Reset the min-height of all slides
      set_stat_height();

      // Set the visibility of the navigation
      set_navigation_visibility();

    });
  
    // Set slider args
    var $slick_args = {
      'arrows': false,
      'dots': false,
      'infinite': true,
      'regionLabel': 'Stats Slider',
      'slidesToShow': 5,
      'slidesToScroll': 1,
      'responsive': [
        {
          'breakpoint': 1901,
          'settings': {
            'slidesToShow': 4
          }
        },
        {
          'breakpoint': 1501,
          'settings': {
            'slidesToShow': 3
          }
        },
        {
          'breakpoint': 1025,
          'settings': {
            'centerMode': true,
            'centerPadding': '25%',
            'slidesToShow': 1
          }
        },
        {
          'breakpoint': 601,
          'settings': {
            'centerMode': false,
            'fade': true,
            'slidesToShow': 1
          }
        }
      ]
    }
  
    // Initiate slider
    $slider.slick($slick_args);

    // Handle window resizing
    $(window).on('scroll', st_throttle(1000, function() {
      set_stat_height();
    }));
  
  });

});